module.exports = __webpack_public_path__ + "static/handbook_editor-142c0d1b36e8d4ce48308ccb580a945c.jpg";